import { getAxiosClient } from "../../axios-client";
import {
  OfferClientPreAcceptNotificationRequestBody,
  OfferClientPreAcceptNotificationResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerClientPreAcceptNotification = async (
  body: OfferClientPreAcceptNotificationRequestBody
) => {
  return await axiosClient.ax.post<OfferClientPreAcceptNotificationResponse>(
    "/Offers/OfferClientPreAcceptNotification",
    body
  );
};
